<template>
  <div>
    <el-card class="page-container">
      <el-row class="title-biaoti">用户余额汇率换算配置</el-row>
      <el-row class="search"
        ><el-button type="primary" @click="query" :loading="login">刷新 </el-button>
        <el-button type="warning" @click="operate(1)">新增 </el-button></el-row
      >
      <el-row>
        <el-table :data="datalist" style="width: 100%" v-loading="login" stripe border>
          <el-table-column prop="sourceCurrency" label="源货币"> </el-table-column>
          <el-table-column prop="targetCurrency" label="兑换目标货币"> </el-table-column>
          <el-table-column prop="rate" label="汇率"> </el-table-column>
          <el-table-column prop="serviceCharge" label="手续费"> </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
          <el-table-column prop="createDate" label="创建时间"> </el-table-column>
          <el-table-column prop="fixDate" label="修改时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope"
              ><el-button type="primary" @click="operate(2, scope.row)" size="mini"
                >修改
              </el-button>
              <el-button type="danger" @click="operate(3, scope.row.id)" size="mini"
                >删除
              </el-button>
            </template></el-table-column
          >
        </el-table>
      </el-row>
      <el-dialog
        :title="type ? '新增配置' : '编辑配置'"
        :visible.sync="dialog"
        width="50%"
        :before-close="handleClose"
      >
        <div class="item">
          <span>源货币：</span
          ><el-select v-model="data.source" placeholder="">
            <el-option
              v-for="(item, itemIndex) in currencylist"
              :key="itemIndex"
              :label="item.currencyType"
              :value="item.currencyCode"
            ></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>目标货币：</span
          ><el-select v-model="data.target" placeholder="">
            <el-option
              v-for="(item, itemIndex) in currencylist"
              :key="itemIndex"
              :label="item.currencyType"
              :value="item.currencyCode"
            ></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>汇率：</span><el-input type="text" v-model="data.rate"></el-input>
        </div>
        <div class="item">
          <span>手续费：</span
          ><el-input type="text" v-model="data.serviceCharge"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="operate(4)" type="primary" v-if="type"> 新 增 </el-button>
          <el-button @click="operate(5)" type="primary" v-if="!type"> 编 辑 </el-button>
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
    <el-card class="page-container">
      <el-row class="title-biaoti">用户余额汇率换算配置操作记录</el-row>
      <el-row class="search"
        ><el-button type="primary" @click="query1" :loading="login1">刷新 </el-button>
      </el-row>
      <el-row>
        <el-table :data="datalist1" style="width: 100%" v-loading="login1" stripe border>
          <el-table-column prop="dataId" label="源数据id"> </el-table-column>
          <el-table-column prop="opType" label="操作类型">
            <template slot-scope="scope">
              <p v-if="scope.row.opType == 1">增加</p>
              <p v-if="scope.row.opType == 2">修改</p>
              <p v-if="scope.row.opType == 3">删除</p>
            </template>
          </el-table-column>
          <el-table-column prop="sourceCurrency" label="源货币"> </el-table-column>
          <el-table-column prop="targetCurrency" label="兑换目标货币"> </el-table-column>
          <el-table-column prop="rate" label="汇率"> </el-table-column>
          <el-table-column prop="serviceCharge" label="手续费"> </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
          <el-table-column prop="createDate" label="创建时间"> </el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      login: false,
      login1: false,
      datalist: [],
      datalist1: [],
      currencylist: [],
      dialog: false,
      type: true,
      data: {
        id: "",
        source: "",
        target: "",
        rate: "",
        serviceCharge: "",
      },
    };
  },
  created() {
    this.query();
    this.query1();
    this.currencyQuery();
  },
  methods: {
    async currencyQuery() {
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.config_currency_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      });
      this.currencylist = res.data.data;
    },
    async query() {
      this.login = true;
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.config_rate_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      });
      this.login = false;
      if (res.code != 0) return this.$message(res.msg);
      this.datalist = res.data.data;
    },
    async query1() {
      this.login1 = true;
      const { data: res } = await this.$axios({
        type: "GET",
        url: this.$store.getters.path.config_ratelog_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      });
      this.login1 = false;
      if (res.code != 0) return this.$message(res.msg);
      this.datalist1 = res.data.data;
    },
    async operate(type, obj) {
      if (type == 1) {
        this.dialog = true;
        this.type = true;
      } else if (type == 2) {
        this.type = false;
        this.dialog = true;
        this.data.id = obj.id;
        this.data.source = obj.sourceCurrencyCode;
        this.data.target = obj.targetCurrencyCode;
        this.data.rate = obj.rate;
        this.data.serviceCharge = obj.serviceCharge;
      } else if (type == 3) {
        this.$confirm("确认删除此项配置", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const { data: res } = await this.$axios(
              this.$store.getters.path.config_rate_delete +
                "?username=" +
                this.$store.getters.username +
                "&token=" +
                this.$store.getters.token +
                "&id=" +
                obj,
              {}
            );
            if (res.code !== 0) return this.$message.error("删除失败");
            this.$message.success("删除成功");
            this.query();
            this.query1();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else if (type == 4) {
        const { data: res } = await this.$axios({
          type: "GET",
          url: this.$store.getters.path.config_rate_add,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
            source: this.data.source,
            target: this.data.target,
            rate: this.data.rate,
            serviceCharge: this.data.serviceCharge,
          },
        });
        this.handleClose();
        if (res.code != 0) return this.$message(res.msg);
        this.query();
        this.query1();
      } else if (type == 5) {
        const { data: res } = await this.$axios({
          type: "GET",
          url: this.$store.getters.path.config_rate_update,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
            id: this.data.id,
            source: this.data.source,
            target: this.data.target,
            rate: this.data.rate,
            serviceCharge: this.data.serviceCharge,
          },
        });
        this.handleClose();
        if (res.code != 0) return this.$message(res.msg);
        this.query();
        this.query1();
      }
    },
    handleClose() {
      this.data = {
        id: "",
        source: "",
        target: "",
        rate: "",
        serviceCharge: "",
      };
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  > * {
    margin: 0 3px;
  }
}
.item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
